export default __webpack_public_path__ + "static/media/downArrow.8f9024fa.svg";